import React from "react";
import { Heart, MessageCircle, Send, Bookmark, MoreHorizontal, Globe, ThumbsUp, Share2 } from "lucide-react";

function BrandRow({ brandName, logo, sub }) {
  return (
    <div className="flex items-center gap-2 px-3 py-2.5">
      {logo ? (
        <img src={logo} alt="" className="h-8 w-8 rounded-full object-cover" />
      ) : (
        <div className="h-8 w-8 rounded-full bg-lime-400 flex items-center justify-center">
          <span className="font-display font-extrabold text-sm text-[#0A0D0E]">{(brandName || "K")[0]}</span>
        </div>
      )}
      <div className="min-w-0 flex-1">
        <div className="text-[13px] font-semibold text-white leading-tight truncate">{brandName || "KARYOW"}</div>
        <div className="text-[11px] text-zinc-500 leading-tight">{sub}</div>
      </div>
      <MoreHorizontal className="h-4 w-4 text-zinc-500" />
    </div>
  );
}

export function InstagramMockup({ image, headline, primaryText, cta, brandName, logo }) {
  return (
    <div data-testid="mockup-instagram" className="w-full max-w-sm mx-auto rounded-xl overflow-hidden border border-[#242B30] bg-[#0F1315]">
      <BrandRow brandName={brandName} logo={logo} sub="Sponsored" />
      <div className="aspect-square w-full bg-[#0A0D0E]">
        {image ? <img src={image} alt="ad" className="h-full w-full object-cover" /> :
          <div className="h-full w-full flex items-center justify-center text-zinc-600 text-xs font-mono">No photo yet</div>}
      </div>
      <div className="flex items-center gap-4 px-3 pt-3">
        <Heart className="h-5 w-5 text-white" />
        <MessageCircle className="h-5 w-5 text-white" />
        <Send className="h-5 w-5 text-white" />
        <Bookmark className="h-5 w-5 text-white ml-auto" />
      </div>
      <div className="px-3 py-2">
        <p className="text-[13px] text-zinc-200 leading-snug">
          <span className="font-semibold text-white mr-1">{(brandName || "karyow").toLowerCase().replace(/\s+/g, "")}</span>
          {primaryText}
        </p>
      </div>
      <button className="mx-3 mb-3 w-[calc(100%-1.5rem)] rounded-md bg-lime-400 text-[#0A0D0E] text-sm font-semibold py-2 flex items-center justify-between px-3">
        <span className="truncate">{headline}</span>
        <span className="text-xs font-mono">{cta} →</span>
      </button>
    </div>
  );
}

export function FacebookMockup({ image, headline, primaryText, cta, brandName, logo }) {
  return (
    <div data-testid="mockup-facebook" className="w-full max-w-sm mx-auto rounded-xl overflow-hidden border border-[#242B30] bg-[#0F1315]">
      <BrandRow brandName={brandName} logo={logo} sub={<span className="flex items-center gap-1">Sponsored · <Globe className="h-3 w-3" /></span>} />
      <div className="px-3 pb-2">
        <p className="text-[13px] text-zinc-200 leading-snug">{primaryText}</p>
      </div>
      <div className="aspect-[1.91/1] w-full bg-[#0A0D0E]">
        {image ? <img src={image} alt="ad" className="h-full w-full object-cover" /> :
          <div className="h-full w-full flex items-center justify-center text-zinc-600 text-xs font-mono">No photo yet</div>}
      </div>
      <div className="flex items-center justify-between gap-3 bg-[#14181B] border-t border-[#242B30] px-3 py-2.5">
        <div className="min-w-0">
          <div className="text-[10px] font-mono uppercase tracking-wider text-zinc-500">karyow.com</div>
          <div className="text-[13px] font-semibold text-white truncate">{headline}</div>
        </div>
        <button className="shrink-0 rounded-md bg-lime-400 text-[#0A0D0E] text-xs font-semibold px-3 py-2">{cta}</button>
      </div>
      <div className="flex items-center justify-around px-3 py-2 border-t border-[#242B30] text-zinc-400 text-xs">
        <span className="flex items-center gap-1.5"><ThumbsUp className="h-4 w-4" /> Like</span>
        <span className="flex items-center gap-1.5"><MessageCircle className="h-4 w-4" /> Comment</span>
        <span className="flex items-center gap-1.5"><Share2 className="h-4 w-4" /> Share</span>
      </div>
    </div>
  );
}
